import Cookies from 'universal-cookie';
import { getConfigData, getGlobalScriptsForCustomerApi, markCodeRedeemedApiCall, redeemEntryCodeApiCall, updateVBPInnerApi, webhookRegisterApi } from "../util/api_calls/RandomizerApi";
import { decodeOtherLanguage } from "../util/helpers/Helpers";
import {
  playNowApiCall,
  fetchOfferCall,
  voteCall,updateInventoryAPICall,updateOptinToVoteAPICall
} from "../util/api_calls/RandomizerApi";
import Fingerprint from 'fingerprintjs'
import { trackSession, trackVote } from "../actions/TrackingActions";
import { trackOptin } from '../actions/TrackingActions';
import { showEmbedFooter } from '../util/helpers/Helpers';
import { RANDOMIZER_REDUCE_INVENTORY_ON_SHOW_LIST } from '../util/config/Constants';
import { OFFER_TYPE } from '../util/config/app-config';

const getConfig = (hash, dispatch) => {
  getConfigData(
    hash,
    payload => {
      const { data } = payload;
      if (
        data.hasOwnProperty("legacyCharEncoding") &&
        data.legacyCharEncoding == 0
      ) {
        data.detail = decodeOtherLanguage(data.detail);
        data.description = decodeOtherLanguage(data.description);
        data.lastPageCopy = decodeOtherLanguage(data.lastPageCopy);
        data.thanksCopy = decodeOtherLanguage(data.thanksCopy);
        data.drawCopy = decodeOtherLanguage(data.drawCopy);
      }
      dispatch(getConfigFinish(payload));
    },
    error => {
      dispatch(getConfigError(error));
    }
  );

  return {
    type: "GET_CONFIG_START",
    payload: {}
  };
};

const getConfigFinish = payload => {
  return {
    type: "GET_CONFIG_FINISH",
    payload: {
      ...payload
    }
  };
};

const getConfigError = error => {
  let payload = {};
  if (error.constructor.name === "Error") {
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "GET_CONFIG_ERROR",
    payload: payload
  };
};

const submitPlay = (reduceOfferOnBtnClick, hash, formData, props) => {
  localStorage.setItem(`${props.config.id}-optData`, JSON.stringify(formData));
  playNowApiCall(
    formData,
    payload => {
      props.dispatch(playNowFinish(reduceOfferOnBtnClick, formData.optin, hash, payload, props));
    },
    error => {
      props.dispatch(playNowError(error));
    }
  );

  return {
    type: "SUBMIT_START",
    payload: {}
  };
};

const playNowFinish = (reduceOfferOnBtnClick, optin, hash, payload, props) => {
  const cookies = new Cookies();
  const wrapOptin = payload.data.wrapData;
  // const idOptinRandomizer = Number(payload.data.idOptinRandomizer);
  cookies.set('idOptin', wrapOptin, { path: '/' });
  localStorage.setItem(`${props.config.id}-idOptin`, wrapOptin);

  if (optin) {
    const { flakeId } = props.tracking;
    props.dispatch(trackOptin(props.config.id, payload.data.idOptin, flakeId, props.dispatch));
  }

  props.dispatch(
    getOffer(props.history, props.config.id, wrapOptin, hash, props, props.dispatch, reduceOfferOnBtnClick)
  );

  return {
    type: "SUBMIT_FINISH",
    payload: {
      ...payload
    }
  };
};

const playNowError = error => {
  let payload = {};
  console.log('entry-error', error);
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }

  return {
    type: "SUBMIT_ERROR",
    payload: payload
  };
};

const getOfferAgain = (id, wrapOptin, hash, props, reduceOfferOnBtnClick) => {
  fetchOfferCall(
    id,
    { wrapOptin },
    payload => {
      props.dispatch(offerFinish(props.history, id, hash, props, payload, reduceOfferOnBtnClick));
    },
    error => {
      props.dispatch(offerError(hash, error));
    }
  );

  return {
    type: "OFFER_START",
    payload: {}
  };
};

const getOffer = (history, id, wrapOptin, hash, props, dispatch, reduceOfferOnBtnClick) => {
  fetchOfferCall(
    id,
    { wrapOptin },
    payload => {
      dispatch(offerFinish(history, id, hash, props, payload, reduceOfferOnBtnClick));
    },
    error => {
      dispatch(offerError(history, hash, error));
    }
  );

  return {
    type: "OFFER_START",
    payload: {}
  };
};

const offerFinish = (history, idCompetition, hash, props, payload, reduceOfferOnBtnClick) => {
  console.log('offerrrrr', payload);

  if (payload && payload.data) {
    const data = payload.data;
    if (idCompetition) {
      localStorage.setItem(`${idCompetition}-offer`, JSON.stringify(data));
    }

    const hasEmbedFooter = showEmbedFooter();
    if (hash.includes("/")) {
      if(hasEmbedFooter){
        history.push(hash + "/offer/?embed=true");
      }else{
        history.push(hash + "/offer");
      }
    } else if (hash.includes("__CURL_")) {
      if (hasEmbedFooter) {
        history.push(`offer?embed=true`);
      } else {
        history.push(`offer`);
      }
    } else {
      if(hasEmbedFooter){
        history.push("/offer/?embed=true#" + hash);
      }else{
        history.push("/offer#" + hash);
      }
    }

    // const idOptin = localStorage.getItem(`${idCompetition}-idOptin`);
    // const idVote = localStorage.getItem(`${idCompetition}-idVote`);

    // if (RANDOMIZER_REDUCE_INVENTORY_ON_SHOW_LIST.includes(idCompetition)
    //   && idOptin && !idVote && data.type === OFFER_TYPE.OFFER) {
    //   let params = {
    //     selectionIds: [{ questionId: data.id, selectionId: 0 }],
    //     idCompetition
    //   };

    //   props.dispatch(updateVote(props, params, props.dispatch, true));
    // }

  }

  // if (reduceOfferOnBtnClick) {
  //   const hasEmbedFooter = showEmbedFooter();
  //   if (hash.includes("/")) {
  //     if(hasEmbedFooter){
  //       history.push(hash + "/offer/?embed=true");
  //     }else{
  //       history.push(hash + "/offer");
  //     }
  //   } else if (hash.includes("__CURL_")) {
  //     if (hasEmbedFooter) {
  //       history.push(`offer?embed=true`);
  //     } else {
  //       history.push(`offer`);
  //     }
  //   } else {
  //     if(hasEmbedFooter){
  //       history.push("/offer/?embed=true#" + hash);
  //     }else{
  //       history.push("/offer#" + hash);
  //     }
  //   }

  // }

  return {
    type: "OFFER_FINISH",
    payload: { ...payload }
  };
};

const offerError = (history, hash, error) => {
  let payload = {};
  if (error && error.constructor && error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."],
      hasError: true
    };
  } else {
    payload = { ...error, hasError: true };
  }
  return {
    type: "OFFER_ERROR",
    payload: payload
  };
};

const updateVote = (props, param, dispatch, reduceOfferOnBtnClick) => {
  voteCall(
    param,
    payload => {
      dispatch(voteFinish(props, payload, reduceOfferOnBtnClick));
    },
    error => {
      dispatch(voteError(error));
    }
  );

  return {
    type: "VOTE_START",
    payload: {}
  };
};

const voteFinish = (props, payload, reduceOfferOnBtnClick) => {
  const idVote = payload.data.idVote;
  const cookies = new Cookies();
  cookies.set('idVote', idVote, { path: '/' });
  localStorage.setItem(`${props.config.id}-idVote`, idVote);
  const idOptin = cookies.get('idOptin');
  if (idVote && props.config && idVote && idOptin) {
    props.dispatch(updateOptinToVote(props.config.id, { idOptin: idOptin, idVote: idVote }, props.dispatch));
  }
  return {
    type: "VOTE_FINISH",
    payload: { ...payload }
  };
};

const voteError = error => {
  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "VOTE_ERROR",
    payload: payload
  };
};



const updateEvent = (history,param, dispatch) => {
  voteCall(
    param,
    payload => {
      dispatch(eventFinish(history,payload));
    },
    error => {
      dispatch(eventError(error));
    }
  );

  return {
    type: "EVENT_START",
    payload: {}
  };
};

const eventFinish = (history,payload) => {
  //history.push("/offer");
  return {
    type: "EVENT_FINISH",
    payload: { ...payload }
  };
};

const eventError = error => {
  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "VOTE_ERROR",
    payload: payload
  };
};

const markCodeRedeemed = (id,param, dispatch) => {
  markCodeRedeemedApiCall(
    param,
    payload => {
      dispatch(inventoryFinish(payload));
    },
    error => {
      dispatch(inventoryError(error));
    }
  );
  return {
    type: "INVENTORY_START",
    payload: {}
  };
};

const updateInventory = (id,param, dispatch) => {
  updateInventoryAPICall(
    id,
    param,
    payload => {
      dispatch(inventoryFinish(payload));
    },
    error => {
      dispatch(inventoryError(error));
    }
  );
  return {
    type: "INVENTORY_START",
    payload: {}
  };
};

const inventoryFinish = payload => {
  return {
    type: "INVENTORY_FINISH",
    payload: { ...payload }
  };
};

const inventoryError = error => {
  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "VOTE_ERROR",
    payload: payload
  };
};


const updateOptinToVote = (id,param, dispatch) => {
  updateOptinToVoteAPICall(
    id,
    param,
    payload => {
      dispatch(updateOptinToVoteFinish(payload));
    },
    error => {
      dispatch(updateOptinToVoteError(error));
    }
  );
  return {
    type: "OPTIN_TO_VOTE_START",
    payload: {}
  };
};

const updateOptinToVoteFinish = payload => {
  return {
    type: "OPTIN_TO_VOTE_FINISH",
    payload: { ...payload }
  };
};

const updateOptinToVoteError = error => {
  let payload = {};
  if (error.constructor.name === "Error") {
    // In case 500 is received I don't want to show server's raw error.
    payload = {
      errorMessages: ["There was an error, please contact support."]
    };
  } else {
    payload = { ...error };
  }
  return {
    type: "OPTIN_TO_VOTE_ERROR",
    payload: payload
  };
};

const webhookRegister = (parameters, dispatch) => {

    webhookRegisterApi(
        parameters,
        payload => {
            dispatch(webhookRegisterFinish(payload))
        },
        error => {
            dispatch(playNowError(error))
        }
    );

    return {
        type: 'POST_SIGNUP_START',
        payload: parameters
    }
}

const webhookRegisterFinish = payload => {
    return {
        type: 'WEBHOOK_REGISTER_FINISH',
        payload: {
            ...payload,
        }
    }
}


const getGlobalScriptsForCustomer = (hash, dispatch) => {

    getGlobalScriptsForCustomerApi(
        hash,
        payload => {
            dispatch(getGlobalScriptsForCustomerFinish(payload.hash, payload, dispatch))
        },
        error => {
            dispatch(playNowError(error))
        }
    );

    return {
        type: 'GET_GLOBAL_SCRIPTS_START',
        payload: {}
    }
}

const getGlobalScriptsForCustomerFinish = (hash, payload, dispatch) => {

    console.log("Looking for global scripts for customer...");

    return {
        type: 'GET_GLOBAL_SCRIPTS_FINISH',
        payload: {
            ...payload
        }
    }
}

const updateVBPInner = (idCompetition, data, dispatch) => {

    updateVBPInnerApi(
        idCompetition,
        data,
        payload => {
            dispatch(updateVBPInnerFinish(payload))
        },
        error => {
            dispatch(playNowError(error))
        }
    );

    return {
        type: 'UPDATE_VB_START',
        payload: {}
    }
}

const updateVBPInnerFinish = payload => {

    return {
        type: 'UPDATE_VB_FINISH',
        payload
    }
}

const redeemEntryCodeFinish = payload => {
  return {
    type: "REDEEM_ENTRY_FINISH",
    payload: { ...payload }
  };
};

const redeemEntryCodeError = error => {
  let payload = {};
  console.log('red-action', error);
  // if (error.constructor.name === "Error") {
  //   // In case 500 is received I don't want to show server's raw error.
  //   payload = {
  //     errorMessages: ["There was an error, please contact support."]
  //   };
  // } else {
    payload = { ...error };
  // }
  return {
    type: "REDEEM_ENTRY_ERROR",
    payload: payload
  };
};

const redeemEntryCode = (param, dispatch) => {
  redeemEntryCodeApiCall(
    param,
    payload => {
      dispatch(redeemEntryCodeFinish(payload));
    },
    error => {
      dispatch(redeemEntryCodeError(error));
    }
  );
  return {
    type: "REDEEM_ENTRY_START",
    payload: {}
  };
};

export { getConfig, submitPlay, getOffer, getOfferAgain, updateVote, updateInventory,
  updateEvent,updateOptinToVote, markCodeRedeemed, webhookRegister, getGlobalScriptsForCustomer,
  updateVBPInner, redeemEntryCode };
